import { useEffect } from "react";
import { API } from "../lib/api";
import { hexToHsl } from "../lib/branding";

const apply = (b) => {
  let link = document.querySelector("link[rel='icon']");
  if (!link) { link = document.createElement("link"); link.rel = "icon"; document.head.appendChild(link); }
  link.href = b.favicon ? `${process.env.REACT_APP_BACKEND_URL}${b.favicon}` : "/favicon.ico";
};

const FIELD = "input:not([type=checkbox]):not([type=radio]):not([type=range]):not([type=color]):not([type=file]), textarea, select";

export function themeCss(t) {
  const r = [], root = [];
  if (t.sidebar_bg) r.push(`.bos-sidebar{background:${t.sidebar_bg} !important}`);
  if (t.sidebar_text) r.push(`.bos-sidebar .bos-nav-item{color:${t.sidebar_text} !important}`);
  if (t.sidebar_font) r.push(`.bos-sidebar{font-family:'${t.sidebar_font}',sans-serif}`);
  if (t.border_color || t.border_width != null) {
    const c = t.border_color || "#C2A462", w = t.border_width ?? 1;
    r.push(`.bos-sidebar{border-right:${w}px solid ${c} !important}`, `.bg-card.border{border-color:color-mix(in srgb, ${c} 45%, transparent) !important;border-width:${w}px !important}`);
  }
  if (t.panel_bg) root.push(`--card:${hexToHsl(t.panel_bg)}`);
  if (t.page_bg) root.push(`--background:${hexToHsl(t.page_bg)}`);
  const title = [t.title_size && `font-size:${t.title_size}px`, t.title_font && `font-family:'${t.title_font}',sans-serif`, t.title_color && `color:${t.title_color}`].filter(Boolean);
  if (title.length) r.push(`[data-testid=page-title]{${title.join(";")} !important}`);
  const field = [t.field_bg && `background-color:${t.field_bg} !important`, t.field_border && `border-color:${t.field_border} !important`, t.field_text && `color:${t.field_text} !important`].filter(Boolean);
  if (field.length) r.push(`${FIELD}{${field.join(";")}}`);
  if (root.length) r.push(`:root{${root.join(";")}}`);
  return r.join("\n");
}

export function loadFonts(fonts) {
  const fams = [...new Set(fonts.filter(Boolean))].filter((f) => !["Manrope", "Cormorant Garamond"].includes(f));
  let el = document.getElementById("bos-theme-fonts");
  if (!fams.length) { el?.remove(); return; }
  if (!el) { el = document.createElement("link"); el.id = "bos-theme-fonts"; el.rel = "stylesheet"; document.head.appendChild(el); }
  el.href = `https://fonts.googleapis.com/css2?${fams.map((f) => `family=${f.replace(/ /g, "+")}:wght@400;600;700`).join("&")}&display=swap`;
}

const applyTheme = (t) => {
  let el = document.getElementById("bos-theme");
  if (!el) { el = document.createElement("style"); el.id = "bos-theme"; document.head.appendChild(el); }
  el.textContent = themeCss(t);
  loadFonts([t.sidebar_font, t.title_font]);
};

export function BrandingHead() {
  useEffect(() => {
    const load = () => fetch(`${API}/public/branding`).then((r) => r.json()).then(apply).catch(() => {});
    const theme = () => fetch(`${API}/public/theme`).then((r) => r.json()).then((d) => applyTheme(d.theme || {})).catch(() => {});
    load(); theme();
    window.addEventListener("branding-updated", load);
    window.addEventListener("theme-updated", theme);
    return () => { window.removeEventListener("branding-updated", load); window.removeEventListener("theme-updated", theme); };
  }, []);
  return null;
}
